import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { getAvailableStatusTransitions, getMainTenantStatus, getTenantDisplayName } from '../tenantHelpers';

const ChangeStatusModal = ({ tenant, isOpen, onClose, onConfirm, isSaving, error }) => {
  const [newStatus, setNewStatus] = useState('');

  useEffect(() => {
    if (tenant) setNewStatus('');
  }, [tenant]);

  if (!isOpen || !tenant) return null;

  const current = getMainTenantStatus(tenant);
  const options = getAvailableStatusTransitions(tenant);

  return (
    <div className="stm-modal-overlay" onClick={onClose}>
      <div className="stm-modal stm-modal--sm" onClick={(event) => event.stopPropagation()}>
        <header className="stm-modal__header">
          <div>
            <h2>Change status</h2>
            <p>{getTenantDisplayName(tenant)}</p>
          </div>
          <button type="button" className="stm-icon-btn" onClick={onClose} disabled={isSaving} aria-label="Close">
            <FaTimes />
          </button>
        </header>
        <div className="stm-modal__body">
          <div className="stm-status-picker">
            <div className="stm-status-picker__current">
              <span>Current status</span>
              <strong>{current}</strong>
            </div>
            <div className="stm-status-picker__options">
              <span>Change to</span>
              {options.map((option) => (
                <label key={option} className={`stm-radio-option ${newStatus === option ? 'is-selected' : ''}`}>
                  <input
                    type="radio"
                    name="newStatus"
                    value={option}
                    checked={newStatus === option}
                    onChange={() => setNewStatus(option)}
                  />
                  {option}
                </label>
              ))}
            </div>
          </div>
          {error && <p className="stm-field-error">{error}</p>}
        </div>
        <footer className="stm-modal__footer">
          <button type="button" className="stm-btn stm-btn--secondary" onClick={onClose} disabled={isSaving}>Cancel</button>
          <button
            type="button"
            className="stm-btn stm-btn--primary"
            disabled={isSaving || !newStatus}
            onClick={() => onConfirm(newStatus)}
          >
            {isSaving ? 'Saving...' : 'Save'}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default ChangeStatusModal;
